import {Currency} from "@/models/Security/Currency";

/**
 * @param number {Number}
 * @param decimals
 * @param decPoint
 * @param thousandsSep
 * @return {string}
 */
export function number_format(number, decimals, decPoint, thousandsSep) {
     return Currency.format(number)
}
